export default __webpack_public_path__ + "335b3b2.png";